module.exports = __webpack_public_path__ + "static/media/flexible.31ec528a.svg";